import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { SafePipe } from 'src/app/pipes/safe.pipe'
import { RedirectorService } from 'src/app/service/redirector.service'
import { RouterLink } from '@angular/router'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  selector: 'app-imprint',
  imports: [
    I18nSelectorComponent,
    SafePipe,
    RouterLink,
    UserTokenPipe,
  ],
  templateUrl: './imprint.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './imprint.component.sass',
})
export class ImprintComponent {
  protected context = inject(RedirectorService).getContext()
}
